<template>
  <form @submit.prevent="submit">
    <FormField>
      <Input :invalid="$v.lastName.$error && !$v.lastName.required" v-model="$v.lastName.$model" placeholder="Фамилия" />
      <Error v-if="$v.lastName.$error && !$v.lastName.required">
        Поле обязательнное
      </Error>
    </FormField>
    <FormField>
      <Input :invalid="$v.firstName.$error && !$v.firstName.required" v-model="$v.firstName.$model" placeholder="Имя" />
      <Error v-if="$v.firstName.$error && !$v.firstName.required">
        Поле обязательнное
      </Error>
    </FormField>
    <FormField>
      <Input :invalid="regUsernameError || ($v.username.$error && !$v.username.required)" v-model="$v.username.$model" placeholder="Email или телефон" />
      <Error v-if="$v.username.$error && !$v.username.required">
        Поле обязательнное
      </Error>
      <Error v-if="regUsernameError">
        Такой пользователь уже существует
      </Error>
    </FormField>
    <FormField>
      <Input :invalid="$v.password.$error && !$v.password.required" v-model="$v.password.$model" placeholder="Пароль" type="password" />
      <Error v-if="$v.password.$error && !$v.password.required">
        Поле обязательнное
      </Error>
    </FormField>
    <FormField>
      <Input :invalid="$v.confirmPassword.$error && !$v.confirmPassword.required" v-model="$v.confirmPassword.$model" placeholder="Поврорите пароль" type="password" />
      <Error v-if="$v.confirmPassword.$error && !$v.confirmPassword.required">
        Поле обязательнное
      </Error>
      <Error v-if="$v.confirmPassword.required && $v.confirmPassword.$dirty && !$v.confirmPassword.sameAs">
        Пароль не совпадает
      </Error>
    </FormField>
    <SubmitButton :disabled="$v.$invalid">Зарегистироваться</SubmitButton>
  </form>
</template>


<script>
import axios from 'axios';
import { oauthApi, http, laravelHttp, refBookHttp, receptionHttp } from '@app/services';
import helper from '@app/services/helper';
import { required, sameAs } from 'vuelidate/lib/validators';

import Input from '@app/components/uikit/Input';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import SubmitButton from './submit-button';

export default {
  components: {
    Input, FormField, Error, SubmitButton
  },
  data: () => ({
    firstName: '',
    lastName: '',
    username: '',
    password: '',
    confirmPassword: '',
    regUsernameError: false,
  }),
  validations: {
    firstName: { required },
    lastName: { required },
    username: { required },
    password: { required },
    confirmPassword: {
      required,
      sameAs: sameAs(function() {
        return this.password;
      }),
    },
  },
  methods: {
    async submit() {
      const body = {
        username: this.username,
        password: this.password,
        first_name: this.firstName,
        last_name: this.lastName,
      };
      const httpClient = axios.create();
      delete httpClient.defaults.headers.common['Authorization'];
      try {
        await httpClient.post('/api/auth/register/', body);
        const token = await oauthApi.getTokenByForm(this.username, this.password);
        await this.setToken(token);
        // this.showSignInDialog = false;
        // this.isSignIn = true;
        this.$emit('success');
        this.regUsernameError = false;
        this.$v.$reset;
      } catch (error) {
        this.regUsernameError = !error?.data?.errors?.username[0];
      }
    },
    async setToken(token) {
      // DOTO: Refactoring
      localStorage.setItem('auth_token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      http.setToken(token);
      laravelHttp.setToken(token);
      refBookHttp.setToken(token);
      receptionHttp.setToken(token);
      await helper.check();
      await this.$store.dispatch('permission/loadPermissions');
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
  }
};
</script>
